import { render, staticRenderFns } from "./ManageAdminCardsSidebar.vue?vue&type=template&id=a53c827a&"
import script from "./ManageAdminCardsSidebar.vue?vue&type=script&lang=js&"
export * from "./ManageAdminCardsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a53c827a')) {
      api.createRecord('a53c827a', component.options)
    } else {
      api.reload('a53c827a', component.options)
    }
    module.hot.accept("./ManageAdminCardsSidebar.vue?vue&type=template&id=a53c827a&", function () {
      api.rerender('a53c827a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/manage-admin-cards/ManageAdminCardsSidebar.vue"
export default component.exports